<button id="toggle-sidenav-button"
  class="btn toggle-sidenav-button {{isBurger ? 'burger align-v-center' : 'default'}}"
  [class.opened]="isSidebarOpened"
  (click)="clicked.emit()">

  @if (isBurger) {
    <span class="toggle-sidenav-button-line"></span>
    <span class="toggle-sidenav-button-line"></span>
    <span class="toggle-sidenav-button-line"></span>
  }

  @if (!isBurger) {
    <i class="{{isSidebarOpened ? 'fa fa-chevron-left' : 'fa fa-chevron-right'}}"
      matTooltipPosition="above"
      matTooltip="{{isSidebarOpened ? '' : 'Toggle sidebar'}}">
    </i>
    @if (isSidebarOpened) {
      <span class="label">Collapse sidebar</span>
    }
  }
</button>
